export default __webpack_public_path__ + "static/media/commitment-safe.04979934.png";